/**
 * Error categories for AI agent conversations
 */
export enum ConversationErrorCategory {
  LLM = 'llm',
  STT = 'stt',
  TTS = 'tts',
  TOOL = 'tool',
  CONNECTION = 'connection',
  INTERNAL = 'internal',
}

/**
 * Error severity - determines frontend behavior
 */
export enum ConversationErrorSeverity {
  WARNING = 'warning',
  FATAL = 'fatal',
}

/**
 * Conversation error model emitted via WebSocket
 */
export interface ConversationErrorModel {
  category: ConversationErrorCategory;
  severity: ConversationErrorSeverity;
  code: string;
  userMessage: string;
  debugMessage: string;
  timestamp: number;
  devOnly?: boolean;
}

/**
 * User-friendly default messages per category
 */
export const DEFAULT_USER_MESSAGES: Record<ConversationErrorCategory, string> = {
  [ConversationErrorCategory.LLM]: 'We encountered an error processing your request.',
  [ConversationErrorCategory.STT]: 'We had trouble understanding your speech.',
  [ConversationErrorCategory.TTS]: 'We had trouble generating the audio response.',
  [ConversationErrorCategory.TOOL]: 'An action could not be completed.',
  [ConversationErrorCategory.CONNECTION]: 'We lost connection to the server.',
  [ConversationErrorCategory.INTERNAL]: 'Something went wrong. Please try again.',
};
